import { call, put, takeEvery } from 'redux-saga/effects';
import { OK } from 'http-status-codes';
import { actions, types } from './duck';
import { getNewUsers } from './api';

function* getNewUsersSaga({ userType }) {
  try {
    yield put(actions.getNewUsersRequest(userType));

    const response = yield call(getNewUsers, userType);
    if (response.status === OK) {
      yield put(actions.getNewUsersSuccess(userType, response.data));
    } else {
      yield put(actions.getNewUsersFailure(userType, response.statusText));
    }
  } catch (error) {
    yield put(actions.getNewUsersFailure(userType, error.message));
  }
}

// takeEvery, not takeLatest: a customer fetch and a business fetch are
// independent, and takeLatest would cancel one when the other starts.
export default function* saga() {
  yield takeEvery(types.GET_NEW_USERS, getNewUsersSaga);
}
